import {observer} from "mobx-react";
import * as React from "react";
import {toJS} from "mobx";
import * as moment from "moment";
import {viewChart} from "components/chart/chart";

/**
 * Lists the results of the individual quiz
 *
 */
@observer
class TableChart extends React.Component<{ feedItem: any }> {

  handleViewGraph = () => {
    viewChart(this.props.feedItem._post);
  }

  render() {

    let feedItem = this.props.feedItem;
    let post = feedItem._post;

    const numericAnswer = (step, feedItem) => {
      // need to convert to JS in order for the 'data' to resolve as more than undefined
      const _feedItem = toJS(feedItem);
      if (_feedItem.data) {
        for (let i = 0; i < _feedItem.data.length; i++) {
          if (_feedItem.data[i].stepId === step._id) {
            return _feedItem.data[i].answerValue;
          }
        }
      }
      return '';
    };


    const valueAnswer = (step, feedItem) => {
      // need to convert to JS in order for the 'data' to resolve as more than undefined
      const _feedItem = toJS(feedItem);
      if (_feedItem.data) {
        for (let i = 0; i < _feedItem.data.length; i++) {
          if (_feedItem.data[i].stepId === step._id) {
            let idx = _feedItem.data[i].answerValue;
            if (step.rangeSteps) {
              let values = step.rangeSteps.split(',');
              if (idx > -1 && idx < values.length) {
                return values[idx].trim();
              }
            } else {
              return idx;
            }
          }
        }
      }
      return '';
    };

    /**
     * The stored answer is always an int/index starting at zero
     * representing the index of the choice made.
     *
     * @param step
     * @param feedItem
     */
    const selectedAnswer = (step, feedItem) => {
      let val = 0;
      const _feedItem = toJS(feedItem);
      if (_feedItem.data) {
        for (let i = 0; i < _feedItem.data.length; i++) {
          if (_feedItem.data[i].stepId === step._id) {
            val = _feedItem.data[i].answerValue;
            val++;
            if (step.answers) {
              for (let j = 0; j < step.answers.length; j++) {
                if (step.answers[j].value == val) {
                  return step.answers[j].label;
                }
              }
            }
          }
        }
      }
      return val;
    };

    const resultsDate = moment(feedItem.displayDate).format('dddd, MMMM Do');

    return (
      <div className="tableChart">
        <div className="dateLine">Results from {resultsDate}</div>
        <table>
          <tbody>
          {post.steps.map((step, idx) => {
            if (step.type == "question") {
              const answer = selectedAnswer(step, feedItem);
              return (
                <tr key={`tc-${idx}`}>
                  <td>{step.shortName ? step.shortName : step.content}</td>
                  <td className="answer">{answer}</td>
                </tr>
              );
            } else if (step.type == 'numeric range') {
              const answer = numericAnswer(step, feedItem);
              return (
                <tr key={`tc-${idx}`}>
                  <td>{step.shortName ? step.shortName : step.content}</td>
                  <td className="answer">{answer}</td>
                </tr>
              );
            } else if (step.type == 'value range') {
              const answer = valueAnswer(step, feedItem);
              return (
                <tr key={`tc-${idx}`}>
                  <td>{step.shortName ? step.shortName : step.content}</td>
                  <td className="answer">{answer}</td>
                </tr>
              );
            } else {
              return null;
            }
          })}
          </tbody>
        </table>
        <div className="view-graph"><a onClick={this.handleViewGraph}><i
          className="icon-graph"></i> {post.viewChartButton}</a></div>
      </div>
    );
  }

}

export {TableChart};
